<template>
    <div class="col-12 px-3 my-2" v-show="showPad">
        <div class="row" v-if="title">
            <div class="col-12">
                <h2 class="mb-4">Confirm your name and signature</h2>
            </div>
        </div>

        <el-form :model="form" ref="form" id="sign-pad">
            <el-row :gutter="20">
                <el-col :xs="24" :md="12" :offset="0">
                    <el-form-item label="Name">
                        <el-input class="w-100" v-model="form.name" id="name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12" :offset="0">
                    <el-form-item label="Date">
                        <el-input class="w-100" v-model="form.date" id="date" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12" :offset="0">
                    <el-form-item label="Save Signature for Future use">
                        <el-select v-model="form.saveForFuture" placeholder="Select" class="w-100"
                                   id="saveForFuture">
                            <el-option label="Yes" :value="true"></el-option>
                            <el-option label="No" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :md="12" :offset="0">
                    <el-form-item label="Signature Design">
                        <el-select class="w-100" v-model="form.signatureType" filterable>
                            <el-option
                                v-for="item in signatureTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" v-if="form.signatureType == 'system'" :md="6" :offset="0">
                    <el-form-item label="Font">
                        <el-select class="w-100" v-model="form.selectedFont" filterable
                                   @change="fillSystemSignature">
                            <el-option v-for="font in fonts" :key="font" :label="font" :value="font"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <div class="col-12 px-0 mb-1 mt-3">
                <label for="signature" style="font-weight: bold" v-if="isDraw && contractSignature">
                    Sign Here Using Your Mouse or Touch Screen ( Your Contract will be signed in all the correct
                    places).
                </label>

                <label for="signature" style="font-weight: bold" v-if="isDraw && !contractSignature">
                    Sign Here Using Your Mouse or Touch Screen.
                </label>

                <label for="signature" style="font-weight: bold" v-if="!isDraw">Select your signature font style
                    below.</label>
            </div>

            <div class="signature-wrapper" :class="{ 'has-signature': hasSignature }">
                <VueSignaturePad :width="width" :height="height" ref="signaturePad"
                                 id="signature-pad-1" :options="signaturePadOptions"/>
                <el-button
                    class="clear-signature"
                    v-if="form.signatureType == 'draw' && hasSignature"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    id="signature-pad-clear-btn"
                    @click="clearSignature"
                ></el-button>
            </div>

            <div class="col-12 px-0 mb-1 mt-3" v-if="submitUrl !== null">
                <el-button
                    v-if="submitUrl !== null"
                    type="success"
                    id="approve-btn"
                    :disabled="!allowSubmit"
                    @click="saveOrAdoptSignature"
                    class="py-3 w-100 align-item-center"
                >
                    Save and Adopt Signature
                </el-button>

                <el-button v-else @click="returnSignature" type="success">Continue</el-button>

                <p class="my-1">
                    By selecting Save and Adopt Signature, I agree that the signature will be the electronic
                    representation of my signature when I use it on these documents, just the same as with a
                    pen-and-paper signature.
                </p>
            </div>
        </el-form>
    </div>
    <!-- end step 4 -->
</template>

<script>
import SignaturePad from "signature_pad";
import SignatureStatement from "./SignatureStatement";
import swal from "sweetalert2"

export default {
    components: {
        SignatureStatement
    },
    props: {
        submitUrl: {
            type: String,
        },
        saveSignatureUrl: {
            type: String,
        },
        user: {
            type: Object,
            required: true
        },
        contractSignature: {
            type: Object,
        },
        timelineUrl: {
            type: String,
        },
        verificationSignature: {
            type: Boolean,
            required: false
        },
        title: {
            type: Boolean,
            default: true
        },
        getExistingSignature: {
            required: false
        },
        saveReusableSignature: {
            required: false
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        viewType: {
            required: false,
            default: "portrait-primary",
        },
        width: {
            required: false,
            type: String,
            default: "100%",
        },
        height: {
            required: false,
            type: String,
            default: "300px",
        },
    },
    data() {
        return {
            showPad: true,
            form: {
                name: "",
                date: this.$moment(new Date()).format("DD/MM/YYYY"),
                signatureType: "draw",
                selectedFont: "Bad Script",
                saveForFuture: false
            },
            fonts: ["Bad Script", "Homemade Apple", "Mr De Haviland", "Sacramento"],
            signatureTypes: [
                {
                    label: "Draw Signature",
                    value: "draw",
                },
                {
                    label: "Existing Signature",
                    value: "prev",
                },
                {
                    label: "System Design",
                    value: "system",
                },
            ],
            signaturePadOptions: {
                dotSize: (0.5 + 2.5) / 2,
                minWidth: 0.5,
                maxWidth: 2.5,
                throttle: 16,
                minDistance: 1,
                backgroundColor: "transparent",
                penColor: "black",
                velocityFilterWeight: 0.7,
                onBegin: this.onBegin,
                onEnd: this.onEnd,
            },
            hasSignature: false,
            loadImage: false,
            agree: false,
            submitted: false,
            allowSubmit: true,
            reusableSignature: null,
            hasExistingSignature: false,
            saveForFuture: false
        };
    },
    watch: {
        viewType: {
            handler() {
                this.showPadPortrait = this.viewType == "portrait-primary" ? true : false
                this.$nextTick(() => {
                    this.handleResize()
                })
            },
            immediate: true,
        },
        user: {
            handler(user) {
                if (user) {
                    this.form.name = _.get(user, "full_name", _.get(user, "fullName", _.get(user, 'first_name', '') + ' ' + _.get(user, 'last_name', '')))
                }
            },
            immediate: true,
            deep: true,
        },
        "form.signatureType": {
            handler(signatureType) {
                switch (signatureType) {
                    case "draw":
                        this.openSignaturePad()
                        this.clearSignature()
                        this.checkSignature()
                        break
                    case "prev":
                        if (this.hasExistingSignature) {
                            this.drawFromReusable(this.reusableSignature)
                        }
                        break
                    case "system":
                        this.fillSystemSignature()
                        break
                    default:
                }
            },
            immediate: true,
        },
        "form.name": {
            handler(name) {
                if (this.form.signatureType == "system") {
                    this.fillSystemSignature()
                }
            },
        },
        "form.font": {
            handler(name) {
                if (this.form.signatureType == "system") {
                    this.fillSystemSignature()
                }
            },
        },
        "loadImage": {
            handler(name) {
                if (this.$refs.signaturePad && name) {
                    this.saveSignature()
                }
            },
        }
    },
    created() {
        window.addEventListener("resize", this.handleResize);
    },
    mounted() {
        this.showPad = true;
        window.addEventListener("resize", this.handleResize)
        this.checkSignature()

        this.checkCustomerSignatureExist()
    },
    computed: {
        isDraw() {
            if (this.form.signatureType === 'draw') return false
            return true
        },
        isSignatureEmpty() {
            return this.hasSignature
        }
    },
    methods: {
        checkSignature() {
            let hasSignature = false
            if ((this.form.signatureType == 'system' || this.form.signatureType == 'prev') && _.size(this.form.name) >= 3) {
                hasSignature = true
            } else {
                if (this.$refs.signaturePad) {
                    let canvas = this.$refs.signaturePad.$refs.signaturePadCanvas
                    let ctx = canvas.getContext("2d")
                    let imageData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height)
                    let trans = _.size(imageData.data.filter((data) => data !== 0))
                    let percent = (trans / imageData.data.length) * 100
                    hasSignature = percent >= 0.07 ? true : false
                }
            }

            this.hasSignature = hasSignature

            if (!this.hasSignature) {
                this.$emit("input", {
                    signature: false,
                    signatureType: this.form.signatureType
                })
            }

            return hasSignature
        },
        handleResize() {
            this.resizeCanvas()
        },
        lockSignaturePad() {
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.lockSignaturePad()
            }
        },
        openSignaturePad() {
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.openSignaturePad()
            }
        },
        saveSignature() {
            this.checkSignature()
            if (this.$refs.signaturePad && this.hasSignature) {
                let signature = this.trimCanvas(this.$refs.signaturePad.$refs.signaturePadCanvas)
                this.$emit("input", {
                    signature: signature.toDataURL("image/png"),
                    signatureType: this.form.signatureType
                })

                let data = signature.toDataURL("image/png")
                let sig = this.download(data)
                let formData = new FormData()

                formData.append("signature", sig)
                formData.append("name", this.form.name)
                formData.append("date", this.form.date)
                formData.append("signature_type", this.isDraw)

                if (this.form.saveForFuture) {
                    this._saveReusableSignature(formData)
                }
            } else {
                this.$emit("input", {
                    signature: false,
                    signatureType: this.form.signatureType
                })
            }
        },
        undoSignature() {
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.undoSignature()
                this.checkSignature()
            }
        },
        clearSignature() {
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.clearSignature()
                this.checkSignature()
            }
        },
        resizeCanvas() {
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.resizeCanvas()
            }
        },
        trimCanvas(canvas) {
            function rowBlank(imageData, width, y) {
                for (var x = 0; x < width; ++x) {
                    if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
                }
                return true;
            }

            function columnBlank(imageData, width, x, top, bottom) {
                for (var y = top; y < bottom; ++y) {
                    if (imageData.data[y * width * 4 + x * 4 + 3] !== 0) return false;
                }
                return true;
            }

            var ctx = canvas.getContext("2d");
            var width = canvas.width;
            var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            var top = 0, bottom = imageData.height, left = 0, right = imageData.width;

            while (top < bottom && rowBlank(imageData, width, top)) ++top;
            while (bottom - 1 > top && rowBlank(imageData, width, bottom - 1)) --bottom;
            while (left < right && columnBlank(imageData, width, left, top, bottom)) ++left;
            while (right - 1 > left && columnBlank(imageData, width, right - 1, top, bottom)) --right;

            var trimmed = ctx.getImageData(left, top, right - left, bottom - top);
            var copy = canvas.ownerDocument.createElement("canvas");
            var copyCtx = copy.getContext("2d");
            copy.width = trimmed.width;
            copy.height = trimmed.height;
            copyCtx.putImageData(trimmed, 0, 0);

            return copy;
        },
        fillSystemSignature() {
            if (this.$refs.signaturePad) {
                this.clearSignature()

                let context = this.$refs.signaturePad.$refs.signaturePadCanvas.getContext("2d")

                context.font = "2rem " + this.form.selectedFont

                // if (["Bad Script"].includes(this.form.selectedFont)) {
                //     context.font = "2rem " + this.form.selectedFont
                // }

                // if (["Homemade Apple"].includes(this.form.selectedFont)) {
                //     context.font = "2rem " + this.form.selectedFont
                // }

                if (["Mr De Haviland"].includes(this.form.selectedFont)) {
                    context.font = "3rem " + this.form.selectedFont
                }

                context.fillText(this.form.name, 30, this.height.substring(0, this.height.length - 2) / 2)

                this.saveSignature()

                this.lockSignaturePad()
            }
        },
        onBegin() {
        },
        onEnd() {
            this.saveSignature()
        },
        checkCustomerSignatureExist() {
            axios.get(this.getExistingSignature)
                .then(res => {
                    if (res.data) {
                        console.log('checkCustomerSignatureExist ')
                        this.hasExistingSignature = true
                        this.reusableSignature = _.get(res, 'data')
                    }
                })
        },
        _saveReusableSignature(formData) {
            axios.post(this.saveReusableSignature, formData, {
                headers: {"Content-Type": "multipart/form-data"},
            })
                .then(res => {
                    console.log('checkCustomerSignatureExist ', res)
                })
        },
        drawFromReusable(reusableSignature) {
            if (this.$refs.signaturePad) {
                this.clearSignature() // always clear on update text;

                let canvas = this.$refs.signaturePad.$refs.signaturePadCanvas
                let context = canvas.getContext("2d")

                const load = () => new Promise(resolve => {
                    const img = new Image()

                    img.crossOrigin = '';
                    img.onload = () => resolve(img);
                    img.onerror = () => resolve(img);

                    img.src = reusableSignature
                })

                load().then(res => {
                    context.drawImage(res, 30, 30, 600, 150)

                    this.loadImage = true
                    this.hasSignature = true
                })
            }
        },
        blobToImage(blob) {
            return new Promise(resolve => {
                const url = URL.createObjectURL(blob)
                let img = new Image()
                img.onload = () => {
                    URL.revokeObjectURL(url)
                    resolve(img)
                }
                img.src = url
            })
        },
        returnSignature() {
            if (this.isDraw && !this.hasSignature) {
                // alert("Please provide a signature first.");
                this.$message({message: "Please provide a signature first.", type: "error"})
                return false
            }

            let signature = this.trimCanvas(this.$refs.signaturePad.$refs.signaturePadCanvas)
            let data = signature.toDataURL("image/png")

            this.$bus.$emit("setSignature", data)
            this.$bus.$emit("close-modal", true)
        },
        dataURLToBlob(dataURL) {
            var parts = dataURL.split(";base64,")
            var contentType = parts[0].split(":")[1]
            var raw = window.atob(parts[1])
            var rawLength = raw.length
            var uInt8Array = new Uint8Array(rawLength)

            for (var i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i)
            }

            return new Blob([uInt8Array], {type: contentType})
        },
        download(dataURL) {
            let blob = this.dataURLToBlob(dataURL)
            return blob
        },
        saveOrAdoptSignature() {
            this.checkSignature()

            if (!this.hasSignature) {
                return alert("Please provide a signature first.")
            }

            this.saveSignature()

            this.loading = true

            let signature = this.trimCanvas(this.$refs.signaturePad.$refs.signaturePadCanvas)
            let data = signature.toDataURL("image/png")

            let sig = this.download(data)
            let formData = new FormData()

            formData.append("signature", sig)
            formData.append("name", this.form.name)
            formData.append("date", this.form.date)
            formData.append("signature_type", this.isDraw)

            if (this.form.saveForFuture) {
                this._saveReusableSignature(formData)
            }

            if (this.submitUrl !== null) {
                axios.post(this.saveSignatureUrl, formData, {
                    headers: {"Content-Type": "multipart/form-data"},
                }).then((res) => {
                    this.loading = false
                    this.$store.dispatch("signature/saveCustomerSignature", res.data)
                    this.$bus.$emit("add-signature", true)
                    this.$bus.$emit("close-modal", true)
                    if (this.verificationSignature) this.$bus.$emit("verified", true)
                }).catch((err) => {
                    this.loading = false
                    this.allowSubmit = true
                    console.error(err)
                })
            }
        },

        /**
         * @deprecated
         */
        submit() {
            this.checkSignature()

            if (!this.hasSignature) {
                return alert("Please provide a signature first.")
            }
            this.submitted = true
            this.loading = true

            this.saveSignature()

            let signature = this.trimCanvas(this.$refs.signaturePad.$refs.signaturePadCanvas)

            let data = signature.toDataURL("image/png")

            let sig = this.download(data)
            let formData = new FormData()

            formData.append("signature", sig)
            formData.append("name", this.form.name)
            formData.append("date", this.form.date)
            formData.append("signature_type", this.isDraw)

            if (this.form.saveForFuture) {
                this._saveReusableSignature(formData)
            }

            axios
                .post(this.submitUrl, formData, {
                    headers: {"Content-Type": "multipart/form-data"},
                })
                .then((res) => {
                    this.submitted = true
                    this.loading = false
                    this.$message({
                        message: "Signature Saved",
                        type: "success",
                    })

                    window.location.href = this.timelineUrl
                })
                .catch((err) => {
                    this.submitted = false
                    this.loading = false
                    this.$message({
                        message: "Cannot Submit Contract Signature",
                        type: "error",
                    })
                    console.error(err)
                })
        },
        erase() {
            this.sig1.clear()
        }
    },
};
</script>

<style lang="scss" scoped>
.signature-wrapper {
    border: 1px solid #cccccc;

    &.has-signature {
        border: 1px solid #73bd44;
    }
}

.signature-type-button {
    display: flex;

    .el-radio-button :deep() {
        display: flex;
        width: 100%;

        .el-radio-button__inner {
            width: 100%;
        }
    }
}

.el-form-wrapper {
    margin-bottom: 20px;

    @media screen and (min-width: 768px) {
        margin-bottom: 0;
    }
}
</style>
